/**
 * What the capture page waits on before it signals ready: every block card
 * that might still turn out static, until it has painted or routed to the
 * iframe card. Iframe documents past the capture cap stay posters, so they
 * do not hold the shot; a static block has no poster stage, so it does.
 */

let held = 0;
const waiters = new Set<() => void>();

/** Holds the gate; the returned release is idempotent. */
export function holdStaticBlockPaint(): () => void {
  held++;
  let released = false;
  return () => {
    if (released) return;
    released = true;
    held--;
    // A card may hand its hold to another in the same commit (node → card,
    // placeholder → static card); settle only if nothing took one since.
    if (held === 0) setTimeout(settleIfFree, 0);
  };
}

function settleIfFree(): void {
  if (held > 0) return;
  for (const resolve of [...waiters]) resolve();
}

/** Resolves once nothing holds the gate, or after `timeoutMs`. */
export function staticBlockPaintsSettled(timeoutMs: number): Promise<void> {
  if (held === 0) return Promise.resolve();
  return new Promise((resolve) => {
    const done = () => {
      clearTimeout(timer);
      waiters.delete(done);
      resolve();
    };
    const timer = setTimeout(done, timeoutMs);
    waiters.add(done);
  });
}
